import React from 'react';
import styles from './drawerContent.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import IconClose from '@/assets/icons/icon-round-close.svg';
import { config } from '@/apollo/config';
import { BannerData } from '@/apollo/graphql/types/bannerTypes';

const RightSectionAds = ({
  closeButton,
  bannerData,
}: {
  closeButton: () => void;
  bannerData: BannerData;
}) => {
  return (
    <div className={styles.drawer__rightSectionAds}>
      <button
        type="button"
        className={styles.drawer__closeButton}
        onClick={closeButton}
      >
        <IconClose />
      </button>
      {bannerData?.banners?.totalCount !== 0 && (
        <Link
          onClick={closeButton}
          href={bannerData?.banners?.edges?.[0]?.node?.url || '#'}
          passHref
        >
          <Image
            className={styles.oddImage}
            src={`${config.publicApiUrl}${bannerData?.banners?.edges?.[0]?.node?.image}`}
            alt="odd-image"
            // layout="responsive"
            width={328}
            height={563}
          />
        </Link>
      )}
    </div>
  );
};

export default RightSectionAds;
